import $ from 'jquery';

import AlerterView from 'chairisher/view/alerter';
import Autocomplete from 'chairisher/component/autocomplete';
import BaseController from 'chairisher/_controller';
import Carousel from 'chairisher/component/carousel';
import KeyUtils from 'chairisher/util/key';

import trackGlobalSearch from 'chairisher/analytics/globalsearch';

import { getLoginUrl, isAuthenticated } from 'chairisher/context/auth';
import { getSearchAutocompleteEndpoint } from 'chairisher/context/search';
/**
 * Controller that binds actions for the Pinkbook
 */
class PinkbookController extends BaseController {
    /** @inheritDoc * */
    bindPageActions() {
        super.bindPageActions();

        //
        // Carousel
        //

        new Carousel({ $carousel: $('.js-carousel') }).bind();

        //
        // Autocomplete
        //

        const autocomplete = new Autocomplete({
            $queryEl: $('#js-pinkbook-search .js-autocomplete-query'),
            dataObject: {
                limit: 12,
                sold: 1,
            },
            dataEndpoint: getSearchAutocompleteEndpoint(),
        });

        autocomplete
            .getQueryEl()
            .one('autocomplete:focus', () => {
                if (autocomplete.canMakeQuery()) {
                    autocomplete.fetchData();
                }
            })
            .on('autocomplete:keypress', (e) => {
                if (e.which === KeyUtils.KeyCodes.Enter) {
                    e.preventDefault();

                    const query = autocomplete.getQueryText().toLowerCase().trim();

                    trackGlobalSearch('pinkbook', query);
                    $(e.currentTarget).closest('form').submit();
                }
            })
            .on('autocomplete:selected', (e, item) => {
                trackGlobalSearch('pinkbook', null, item.display || item.additional_display, item.url);
                window.location.href = item.url;
            });

        //
        // See More / Fewer Categories
        //

        $('.js-category-toggle').on('click', () => {
            const $wrapper = $('.js-category-list');
            const $toggletext = $('#js-category-toggle-text');

            $wrapper.toggleClass('expanded-vertical');
            $('.category-toggle .cicon').toggleClass('rotate-180');

            if ($wrapper.hasClass('expanded-vertical')) {
                $toggletext.html('See Fewer Categories');
            } else {
                $toggletext.html('See All Categories');
            }
        });

        if (!isAuthenticated()) {
            AlerterView.info(
                `<span><a href="${getLoginUrl()}?next=${encodeURIComponent(
                    window.location.pathname,
                )}">Sign in</a> to see prices</span>`,
                0, // display indefinitely
            );
        }
    }
}

export default PinkbookController;
